<template>
    <div class="special-content">
        <div class="title-bar">
            <h2 class="title">{{ title }}</h2>
            <div class="price-wrap">
                <span class="pre-price">Chapman Price:</span>
                <span class="price">{{ formatPrice(special.price) }}</span>
            </div>
        </div>
        <ul>
            <li><span>Stock #:</span> {{ special.stockNumber }}</li>
            <li><span>Body:</span> {{ special.bodyType }}</li>
            <li><span>Engine:</span> {{ special.engine }}</li>
            <li><span>Transmission:</span> {{ special.transmission }}</li>
            <li><span>Mileage:</span> {{ special.mileage }}</li>
        </ul>
        <div class="buttons">
            <a
                :href="link"
                class="button"
                target="_blank"
                rel="noopener"
            >
                Vehicle Details
            </a>
        </div>
    </div>
</template>

<script>
import { formatPrice } from '@/plugins/helpers';

export default {
    name: 'UsedSpecial',
    props: {
        baseUrl: {
            type: String,
            required: true,
        },
        special: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        title() {
            if (this.special.model.toLowerCase().indexOf('mazda') > -1)
                return `${this.special.year} ${this.special.model} ${this.special.trim}`;
            if (this.special.trim.toLowerCase().indexOf(this.special.model.toLowerCase()) > -1)
                return `${this.special.year} ${this.special.make} ${this.special.trim}`;
            return `${this.special.year} ${this.special.make} ${this.special.model} ${
                this.special.trim
            }`;
        },
        link() {
            return `${this.baseUrl}${this.special.stockNumber}`;
        },
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price);
        },
    },
};
</script>

<style lang="scss" scoped>
.special-content {
    flex: auto;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 800px) {
        text-align: center;
    }
}
.title-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    margin-bottom: 10px;
    @media screen and (max-width: 1000px) {
        display: block;
    }
}
.title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 10px;
}
.price-wrap {
    margin-bottom: 10px;
}
.pre-price {
    font-size: 24px;
    padding-right: 5px;
}
.price {
    font-size: 26px;
    font-weight: 700;
    color: #479f28;
}
.post-price {
    font-size: 22px;
    padding-left: 5px;
}
ul {
    flex: auto;
    list-style-position: outside;
    margin: 0;
    margin-bottom: 20px;
    padding-left: 14px;
    list-style-type: square;
    li {
        span {
            font-weight: 700;
            color: #404040;
        }
    }
    @media screen and (max-width: 800px) {
        list-style-type: none;
        padding: 0;
    }
}
.buttons {
    display: flex;
    .button {
        flex: auto;
        flex-basis: 0;
        margin-right: 10px;
        &:last-child {
            margin-right: 0;
        }
    }
    @media screen and (max-width: 480px) {
        flex-direction: column;
        .button {
            margin: 0;
            margin-bottom: 10px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
